// client/src/services/storyService.js

import api from './api.js';

export const storyService = {
  // Public
  getStories: (params = '') => api.get(`/stories?${params}`, false),
  getCategories: () => api.get('/stories/categories', false),
  getSubcategories: (categoryid) => api.get(`/stories/subcategories${categoryid ? `?category=${categoryid}` : ''}`, false),
  getStory: (slug) => api.get(`/stories/${slug}`, false),

  // Admin — Stories
  adminGetAll: () => api.get('/stories/admin/all'),
  adminGetStory: (id) => api.get(`/stories/admin/${id}`),
  adminCreateStory: (data) => api.post('/stories/admin', data),
  adminUpdateStory: (id, data) => api.put(`/stories/admin/${id}`, data),
  adminDeleteStory: (id) => api.delete(`/stories/admin/${id}`),

  // Admin — Subcategories
  adminGetSubcategories: () => api.get('/stories/admin/subcategories/all'),
  adminCreateSubcategory: (data) => api.post('/stories/admin/subcategories', data),
  adminUpdateSubcategory: (id, data) => api.put(`/stories/admin/subcategories/${id}`, data),
  adminDeleteSubcategory: (id) => api.delete(`/stories/admin/subcategories/${id}`),
};

export default storyService;